import { useMemo } from 'react'

import { EditorThemeClasses } from '@eastcoal/editor/exports'

import { useThemeStyles } from './style'

export const useEditorTheme = (): EditorThemeClasses => {
  const { cx, styles } = useThemeStyles()

  return useMemo(
    () => ({
      text: {
        base: 'contract-designer-editor-text-base',
        bold: cx(styles.textBold, 'contract-designer-editor-text-bold'),
        code: 'contract-designer-editor-text-code',
        italic: cx(styles.textItalic, 'contract-designer-editor-text-italic'),
        strikethrough: cx(
          styles.textStrikethrough,
          'contract-designer-editor-text-strikethrough'
        ),
        subscript: cx(
          styles.textSubscript,
          'contract-designer-editor-text-subscript'
        ),
        superscript: cx(
          styles.textSuperscript,
          'contract-designer-editor-text-superscript'
        ),
        underline: cx(
          styles.textUnderline,
          'contract-designer-editor-text-underline'
        ),
        underlineStrikethrough: cx(
          styles.textUnderlineStrikethrough,
          'contract-designer-editor-text-underline-strikethrough'
        )
      },
      heading: {
        h1: cx(styles.h1, 'contract-designer-editor-heading-h1'),
        h2: cx(styles.h2, 'contract-designer-editor-heading-h2'),
        h3: cx(styles.h3, 'contract-designer-editor-heading-h3'),
        h4: cx(styles.h4, 'contract-designer-editor-heading-h4')
      },
      list: {
        listitem: cx(styles.listItem, 'contract-designer-editor-list-item'),
        nested: {
          listitem: cx(
            styles.listItemNested,
            'contract-designer-editor-list-item-nested'
          )
        },
        olDepth: [
          cx(styles.ol1, 'contract-designer-editor-ol-depth-1'),
          cx(styles.ol2, 'contract-designer-editor-ol-depth-2'),
          cx(styles.ol3, 'contract-designer-editor-ol-depth-3'),
          cx(styles.ol1, 'contract-designer-editor-ol-depth-4'),
          cx(styles.ol2, 'contract-designer-editor-ol-depth-5'),
          cx(styles.ol3, 'contract-designer-editor-ol-depth-6')
        ],
        ul: cx(styles.ul, 'contract-designer-editor-ul')
      },
      paragraph: cx(styles.paragraph, 'contract-designer-editor-paragraph'),
      image: cx(styles.image, 'contract-designer-editor-image'),
      tableWrapper: cx(
        styles.tableWrapper,
        'contract-designer-editor-table-wrapper'
      ),
      tableScrollableWrapper: cx(
        styles.tableScrollableWrapper,
        'contract-designer-editor-table-scrollable-wrapper'
      ),
      tableController: cx(
        styles.tableController,
        'contract-designer-editor-table-controller'
      ),
      table: cx(styles.table, 'contract-designer-editor-table'),
      tableCell: cx(styles.tableCell, 'contract-designer-editor-table-cell'),
      tableCellHeader: cx(
        styles.tableCellHeader,
        'contract-designer-editor-table-cell-header'
      ),
      tableCellMarked: cx(
        styles.tableCellMarked,
        'contract-designer-editor-table-cell-marked'
      ),
      tableCellSelected: cx(
        styles.tableCellSelected,
        'contract-designer-editor-table-cell-selected'
      ),
      tableSelection: 'table-selection',
      textVariable: cx(
        styles.textVariable,
        'contract-designer-editor-text-variable'
      ),
      tableVariable: cx(
        styles.tableVariable,
        'contract-designer-editor-table-variable'
      )
    }),
    [cx, styles]
  )
}
